import { useContext } from "react";
import LocationStateContext from "../context/LocationStateContext";

const useLocationState = () => {
   const context = useContext(LocationStateContext);
   return context;
};

export default useLocationState;